import { render, staticRenderFns } from "./CustomersByOrigin.vue?vue&type=template&id=d850976c&scoped=true"
import script from "./CustomersByOrigin.vue?vue&type=script&lang=js"
export * from "./CustomersByOrigin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d850976c",
  null
  
)

export default component.exports